import { render, staticRenderFns } from "./RolesScopeCreateEdit.vue?vue&type=template&id=54eb92e6&scoped=true&"
import script from "./RolesScopeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./RolesScopeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./RolesScopeCreateEdit.vue?vue&type=style&index=0&id=54eb92e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb92e6",
  null
  
)

export default component.exports